import { Franchise } from './../../../core/store/franchises/franchise.model';
import { Observable } from 'rxjs';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Group, SubGroup } from '../../../core/store/models';
import { ConvertType } from '../../constants/convert-type.enum';
import { SavingMessage, Severity } from '../../../core/store/types';

export interface ConvertGroupSubgroupModalData {
    groups?: Group[];
    type: ConvertType;
    group?: Group;
    subGroup?: SubGroup;
    title: string;
    isDivisionGroup?: boolean;
    isFranchiseGroup?: boolean;
    isStudioGroup?: boolean;
    franchiseId?: number,
    franchise?: Franchise,
    divisionId?: number,
    studioId: number,
    allGroups$: Observable<Group[]>,
    franchiseGroups$?: Observable<Group[]>,
    notFranchiseGroups$?: Observable<Group[]>,
    divisionGroups$?: Observable<Group[]>,
    notDivisionGroups$?: Observable<Group[]>,
    franchiseGroupTable?: boolean,
    divisionGroupTable?: boolean,
    onConvert?: (convert: any, dialogRef: MatDialogRef<ConvertGroupSubgroupModalComponent>) => void;
}

@Component({
    selector: 'ah-convert-group-subgroup-modal',
    templateUrl: './convert-group-subgroup-modal.component.html',
    styleUrls: ['./convert-group-subgroup-modal.component.scss'],
    standalone: false
})
export class ConvertGroupSubgroupModalComponent implements OnInit {
    type: ConvertType;
    title: string;
    convertForm: UntypedFormGroup;
    groups: Group[];
    group: Group;
    subGroup: SubGroup;
    isShowGroup: boolean = false;
    name: string;
    placeholder: string;
    description: string;
    divisionId: number;
    franchiseId: number;
    studioId: number;
    allGroups$: Observable<Group[]>;
    franchiseGroups$: Observable<Group[]>;
    notFranchiseGroups$: Observable<Group[]>;
    divisionGroups$: Observable<Group[]>;
    notDivisionGroups$: Observable<Group[]>;
    franchise: Franchise;
    franchiseGroupTable: boolean;
    divisionGroupTable: boolean;
    onConvert: (data: any, dialogRef: MatDialogRef<ConvertGroupSubgroupModalComponent>, type: ConvertType) => void;
    savingMessage: SavingMessage[] = [];
    saveDisabled: boolean = true;
    constructor(
        @Inject(MAT_DIALOG_DATA) private data: ConvertGroupSubgroupModalData,
        private fb: UntypedFormBuilder,
        public dialogRef: MatDialogRef<ConvertGroupSubgroupModalComponent>
    ) { }

    ngOnInit(): void {
        this.type = this.data.type;
        this.title = this.data.title;
        this.groups = this.data.groups;
        this.group = this.data.group;
        this.subGroup = this.data.subGroup;
        this.divisionId = this.data.divisionId;
        this.onConvert = this.data.onConvert;
        this.allGroups$ = this.data.allGroups$;
        this.franchiseGroups$ = this.data.franchiseGroups$;
        this.notFranchiseGroups$ = this.data.notFranchiseGroups$;
        this.divisionGroups$ = this.data.divisionGroups$;
        this.notDivisionGroups$ = this.data.notDivisionGroups$;
        this.franchise = this.data.franchise;
        this.isShowGroup = this.type === ConvertType.GroupToSubgroup;
        this.name = this.type === ConvertType.GroupToSubgroup ? this.group.name : this.subGroup.name;
        this.placeholder = this.type === ConvertType.GroupToSubgroup ? 'Subgroup' : 'Group';
        this.description = this.type === ConvertType.GroupToSubgroup ? this.group.description : this.subGroup.description;
        this.franchiseGroupTable = this.data.franchiseGroupTable;
        this.divisionGroupTable = this.data.divisionGroupTable;
        this.convertForm = this.createForm();
        this.convertForm.markAllAsTouched();
    }

    createForm(): UntypedFormGroup {
        return this.fb.group({
            group_id: this.type === ConvertType.GroupToSubgroup ? [null, [Validators.required]] : [null],
            name: [this.name, [Validators.required]],
            description: [this.description]
        })
    }

    save(): void {
        if (this.convertForm.valid) {
            this.saveDisabled = false;
            const data = this.convertForm.value;
            this.savingMessage = [{ severity: Severity.Info, summary: 'Saving...' }];
            if (this.subGroup) {
                data.group_id = this.subGroup.group_id;
            }
            this.onConvert(data, this.dialogRef, this.type)
        } else {
            this.saveDisabled = true;
        }

    }

    selectGroups(event) {
        this.convertForm.patchValue({ group_id: event.id })
    }
}
